
/* injects from baggage-loader */

import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import Loader from "../loader";
import GameNotFound from "../gameNotFound";
import GameListWrapper from "../gameListWrapper";
import Zergling from "../../../helpers/zergling";
import { getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getBetBuilder } from "../../../helpers/terminalRequests/betBuilder";
import { AsianGamesListUpdateReceived } from "../../../actions/asianActions";
import { handleFavoriteGameListSubscriptionData } from "../../../helpers/asianHelpers";
import { ReceiveUpdate, SwarmLoadingDone, SwarmLoadingStart, SwarmReceiveData } from "../../../actions/swarm";
import { StandartGamesListUpdateReceived } from "../../../actions/standartActions";

export const BetBuilderSection = ({ gameType, isAsian, regionId, competitionId, sportAlias, child }) => {
	const dispatch = useDispatch();
	const subscriptionIds = useRef([]);

	const [isLoading, setIsLoading] = useState(false);
	const [betBuilderGames, setBetBuliderGames] = useState([]);
	const [betBuilderIdsToLoad, setBetBuilderIdsToLoad] = useState(10);

	useEffect(() => {
		const request = {
			source: "betting",
			what: {
				sport: ["id", "name", "alias", "order"],
				game: ["id"],
			},

			where: {
				sport: { type: { "@nin": [1, 4] } },
				game: {
					"@or": [{ visible_in_prematch: 1 }, { type: { "@in": [0, 2] } }],
					sportcast_id: { "@gt": 1 },
				},
			},
		};

		Zergling.get(request, "get").then(resp => {
			const sportsList = Object.values(resp.data.sport);
			const gameIds = [];
			sportsList.forEach(sport =>
				gameIds.push(
					...Object.keys(sport.game).map(item => ({
						gameId: +item,
						sportAlias: sport.alias,
					}))
				)
			);

			setBetBuliderGames(gameIds);
		});

		// move this logic to request helper

		return () => subscriptionIds.current.forEach(Zergling.unsubscribe);
	}, []);

	const onScroll = async () => {
		if (isLoading || betBuilderIdsToLoad >= betBuilderGames.length) return;

		const container = document.getElementById("getScrollPosition");

		if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
			setIsLoading(true);
			dispatch(SwarmLoadingStart(dataKey));

			const subscriptionRequest = getBetBuilder(
				betBuilderGames.slice(betBuilderIdsToLoad, betBuilderIdsToLoad + 10),
				gameType
			);
			const subscriptionRequestKey = getBetBuilder(betBuilderGames, gameType);
			const dataKey = getSwarmDataKeyForRequest(subscriptionRequestKey);

			Zergling.subscribe(subscriptionRequest, function (response) {
				dispatch(ReceiveUpdate(response, dataKey, {}));
				if (isAsian) {
					dispatch(
						AsianGamesListUpdateReceived(
							handleFavoriteGameListSubscriptionData(response),
							dataKey,
							{}
						)
					);
				} else {
					dispatch(
						StandartGamesListUpdateReceived(
							handleFavoriteGameListSubscriptionData(response.data),
							dataKey,
							{}
						)
					);
				}
			})
				.then(function (response) {
					subscriptionIds.current.push(response.subid);

					dispatch(SwarmLoadingDone(dataKey));
					dispatch(SwarmReceiveData(response.data, dataKey, {}));
					if (isAsian) {
						dispatch(
							AsianGamesListUpdateReceived(
								handleFavoriteGameListSubscriptionData(response.data),
								dataKey,
								{}
							)
						);
					} else {
						dispatch(
							StandartGamesListUpdateReceived(
								handleFavoriteGameListSubscriptionData(response.data),
								dataKey,
								{}
							)
						);
					}
				})
				.finally(() => {
					setIsLoading(false);
					dispatch(SwarmLoadingDone(dataKey));
				});

			setBetBuilderIdsToLoad(betBuilderIdsToLoad + 10);
		}
	};

	if (gameType) {
		return (
			<div className={`select-sport-contain-m bet-builder ${gameType}`} id="bet-builder-container">
				{(regionId || competitionId) && !child && betBuilderGames.length ? (
					<>
						<GameListWrapper
							onScroll={onScroll}
							gameType={gameType}
							isAsian={isAsian}
							sportAlias={sportAlias}
							regionId={regionId}
							betBuilderGames={betBuilderGames}
							competitionId={competitionId}
						/>
						{isLoading && <Loader component="betBuilder" />}
					</>
				) : (
					child
				)}
			</div>
		);
	} else {
		return <GameNotFound />;
	}
};
